import { useEffect, useState } from 'react'
import EmptyState from '@zera-admin/empty-state'
import CustomButton from 'components/customButton'

import NotFoundImage from 'assets/images/not-found.png'
import EmptyLayout from 'layouts/empty'

import { NotFoundProps } from './types'

const NotFound: React.FunctionComponent<NotFoundProps> = ({
  history,
  match,
}) => {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setIsReady(true)
    }, 1000)
  }, [])

  const primaryAction = (
    <CustomButton name="turn-back-button" onClick={() => history.goBack()}>
      Turn back
    </CustomButton>
  )

  return (
    <EmptyLayout isReady={isReady}>
      <EmptyState
        title="404. That’s an error."
        description={`The requested URL ${match.url} was not found on this server.`}
        image={{
          src: NotFoundImage,
        }}
        actions={primaryAction}
      />
    </EmptyLayout>
  )
}

export default NotFound
